import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import IActionDto from './dtos/IActionDto';
import Action from '@core/models/user/messages/Action';

export default class ActionMapper extends AbstractMapper<IActionDto, Action> {
    createTargetObject(obj: IActionDto, options?: any) {
        return {
            id: obj.Id,
            name: obj.Name.toLowerCase()
        } as Action;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/user/ActionMapper.ts